module.exports = __webpack_public_path__ + "img/z (9).442ee2be.png";